/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoon2 = createReactComponent("moon-2", "IconMoon2", [
  ["path", { d: "M16.418 4.157a8 8 0 0 0 0 15.686", key: "svg-0" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
]);

export { IconMoon2 as default };
//# sourceMappingURL=IconMoon2.js.map
